import { createFileRoute, Outlet } from '@tanstack/react-router';

import { Loading } from '@/components/loading';
import { DistributionBoardProvider } from '@/components/providers/distibution-board';

export const Route = createFileRoute(
    '/(auth)/projects/$projectVersionId/re-inspections/distributionboards/$distributionboardId',
)({
    component: RouteComponent,
    pendingComponent: PendingComponent,
});

function RouteComponent() {
    return <DistributionBoardProvider><Outlet /></DistributionBoardProvider>;
}

function PendingComponent() {
    return <Loading action="Loading distribution board" />;
}
